import { stringify } from "qs";
import { fetch, fetchwithoutToken } from "$utils/utils";
import { queryClient } from "$utils/queryClient";
import { getParcels } from "./Parcel.service";

import config from "$services/config";
import { CacheInvalidationAction } from "$utils/cache";

const { shipping_api_url: shipping_url } = config;

export const getOpById = async (id) => {
  try {
    const { data } = await fetch(`/api/ops/${id}`);

    return data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

export const getPublicOpById = async (id) => {
  try {
    const { data } = await fetchwithoutToken(`/api/public/ops/${id}`);

    return data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

export const getOps = async (params) => {
  try {
    const { data } = await fetch(
      `/api/ops/withoutCache?${stringify(params, { arrayFormat: "brackets" })}`
    );
    return data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

export const getOpsWithParcelAndNoShippingRecord = async (params) => {
  try {
    const data = await fetch(
      "/opsWithParcelAndShippingRecord",
      { params },
      shipping_url
    );
    return data.data;
  } catch (err) {
    console.error(err);
  }
};

// @todo @tech @improve: remove this function from frontend and use it from gateway
export const setOpShippingRecordId = async (id, data) => {
  try {
    const response = await fetch(`/api/ops/${id}/status`, {
      method: "PUT",
      data,
    });
    return response;
  } catch (err) {
    console.error(err);
  }
};

export const updateShippingRecordAndOp = async (id: string, body: any) => {
  try {
    const res = await fetch(
      `/updateShippingRecordAndOp/${id}`,
      { method: "PUT", data: body },
      shipping_url
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};

export const getOpsWithParcel = async (params) => {
  let parcels;
  parcels = await queryClient.getQueryData(["getParcels"]);
  if (!parcels) {
    parcels = await queryClient.fetchQuery(["getParcels"], () => getParcels(), {
      cacheTime: 5 * 60 * 1000,
    });
    await queryClient.setQueryData(["getParcels"], parcels);
  }
  let ops;
  ops = await queryClient.getQueryData([
    CacheInvalidationAction.GET_OPS,
    params,
  ]);
  if (!ops) {
    const { data } = await queryClient.fetchQuery(
      [CacheInvalidationAction.GET_OPS, params],
      () => getOps(params),
      { cacheTime: 5 * 60 * 1000 }
    );
    ops = data?.map((op) => ({
      ...op,
      parcel: parcels.find((parcel) => parcel.opId === op._id),
    }));
  }
  return ops;
};
